export default {
  // Alerts
  alerts: {
    // Info Alert
    info_alert: {
      title: "Няма налична информация",
      description: "Lab Portal не можа да изтегли заявената информация.",
    },
  },
};
